export const constants = {
  showMonth: false,
  fareTrendsData: [],
  dividerWidth: 70,
  barWidth: 56,

  lineHeight: 100,
  svgHeight: 100,
  maxHeightPercent: 80, // Specifies at what percent the max point should lie

  barSVGHeight: 70,
  barMaxHeightPercent: 90, // Specifies at what percent the max point should lie
  barMinHeightPercent: 22, // Specifies at what percent the max point should lie

  // Classes and Styles
  fareTrendWrapperClasses: '',

  fareTrendWrapperStyle: {
    width: '100%',
    float: 'left',
    height: '6.2em',
    overflow: 'hidden',
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 1pX',
    marginBottom: '4px'
  },

  wrapperClasses: '',

  wrapperStyles: {
    width: '100%',
    float: 'left',
    overflowX: 'scroll',
    overflowY: 'hidden'
    // backgroundColor: 'white'
    // marginTop: '2px'
  },

  svgClasses: '',

  svgStyles: {
    height: 100,
    boxShadow: '0 1px 1px rgba(0,0,0,0.2)'
  },

  svgBarStyles: {
    height: 70,
    boxShadow: '0 1px 1px rgba(0,0,0,0.2)',
    backgroundImage: 'linear-gradient(to bottom, #2276e3, #134280)'
  },

  polyLineClasses: '',

  polyLineStyles: {
    fill: 'none',
    stroke: '#2d67b2',
    strokeWidth: '2',
    animation: 'dash 3s linear'
  },

  colors: {
    circleColor: ['green', 'white', '#2d67b2', 'white'], // Array format [min, max, selected, other]
    priceColor: ['green', 'black', '#2d67b2', 'black'],
    barPriceColor: ['#05a441', '#db3333', '#2d67b2', 'black'],
    dateColor: ['grey', 'grey', '#2d67b2', 'grey'],
    strokeColor: '#2d67b2'
  },

  // Attributes
  dateTxtAttributes: { y: '1.1em', fontSize: '10', textAnchor: 'middle' },
  selectedDateTxtAttributes: { y: '9.5em', fontSize: '10', textAnchor: 'middle', fill: '#ffffff' },

  barDateTxtAttributes: { y: '7.2em', fontSize: '9', textAnchor: 'middle' },
  selectedBarDateTxtAttributes: {
    y: '7.2em',
    fontSize: '9',
    textAnchor: 'middle',
    fill: '#ffffff'
  },

  circleAttributes: { r: '5', strokeWidth: '1.5' },

  priceAttributes: { textAnchor: 'middle', fontSize: '10' },
  selectedPriceAttributes: {
    textAnchor: 'middle',
    fontSize: '10',
    fill: '#ffffff',
    fontWeight: 'bold'
  },

  barPriceAttributes: { textAnchor: 'middle', fontSize: '10', fontWeight: 'bold' },
  selectedBarPriceAttributes: {
    textAnchor: 'middle',
    fontSize: '10',
    fill: '#ffffff',
    fontWeight: 'bold'
  },

  lineAttributes: { strokeWidth: '1', stroke: '#ededed', fill: 'none' },

  selectedDividerAttr: { fill: '#b6b4b4', opacity: '0.2' },

  otherDividerAttr: { opacity: '0' },

  selectedBarDividerAttr: { fill: '#0a3061' },

  otherBarDividerAttr: { fill: '#ffffff' },

  keyFrameAnimation: (pointWidth, selectedDayWidth = 0) => {
    const point = selectedDayWidth ? pointWidth - selectedDayWidth : pointWidth;
    if (__CLIENT__) {
      const oldStyle = document.getElementById('keyFrameFT');
      if (oldStyle) {
        oldStyle.parentNode.removeChild(oldStyle);
      }
      const style = document.createElement('style');
      style.setAttribute('id', 'keyFrameFT');
      const dashAnimate = `@keyframes dash {
        0% {stroke-dashoffset: ${point};}
        100% {stroke-dashoffset: 0;}
      }`;
      style.type = 'text/css';
      style.appendChild(document.createTextNode(dashAnimate));
      document.getElementsByTagName('head')[0].appendChild(style);
    }
  }
};
